'use client';

import { c as _c } from "react/compiler-runtime";
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { SENSITIVE_MASK_CHAR } from '@sola/shared-utils/constants.ts';
import { isEncryptedCardMask } from '@sola/shared-utils/credit-cards.ts';
import { InputField, InputFieldProps } from '../input-field/input-field.tsx';
import { resetCCNumberAndCode, useCreditCardFields } from './utils.ts';
export type CardCodeFieldProps = Omit<InputFieldProps, 'maskOptions' | 'placeholder' | 'prefix' | 'type' | 'minLength' | 'maxLength' | 'pattern'>;
export const CardCodeField: React.FC<CardCodeFieldProps> = t0 => {
  const $ = _c(38);
  let fieldProps;
  if ($[0] !== t0) {
    ({
      ...fieldProps
    } = t0);
    $[0] = t0;
    $[1] = fieldProps;
  } else {
    fieldProps = $[1];
  }
  const {
    card,
    validator
  } = useCreditCardFields();
  const formContext = useFormContext();
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["checkout"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[3] !== formContext) {
    t2 = () => {
      resetCCNumberAndCode(formContext);
    };
    $[3] = formContext;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const clearValue = t2;
  let t3;
  if ($[5] !== t) {
    t3 = t("checkout:form.billingFields.securityCodeLabel");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t("checkout:form.card.codeTooltip");
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = card?.code?.size || 3;
  let t6;
  if ($[9] !== t) {
    t6 = t("checkout:form.card.codeInvalid");
    $[9] = t;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = {
      value: t5,
      message: t6
    };
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = card?.code?.size || 3;
  let t9;
  if ($[14] !== t) {
    t9 = t("checkout:form.card.codeInvalid");
    $[14] = t;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = {
      value: t8,
      message: t9
    };
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== card?.code.size || $[20] !== validator) {
    t11 = value => {
      if (isEncryptedCardMask(value)) {
        return true;
      }
      return validator.cvv(value, card?.code?.size || 3).isValid;
    };
    $[19] = card?.code.size;
    $[20] = validator;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== card?.code.size) {
    t12 = {
      mask: [...new Array(card?.code.size || 3).fill(/\d/)]
    };
    $[22] = card?.code.size;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  const t13 = card?.hasEncryptedMask ? clearValue : undefined;
  let t14;
  if ($[24] !== card?.code?.size || $[25] !== card?.hasEncryptedMask || $[26] !== fieldProps) {
    t14 = card?.hasEncryptedMask ? Array(card?.code?.size ?? 3).fill(SENSITIVE_MASK_CHAR).join("") : fieldProps.value;
    $[24] = card?.code?.size;
    $[25] = card?.hasEncryptedMask;
    $[26] = fieldProps;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== fieldProps || $[29] !== t10 || $[30] !== t11 || $[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t3 || $[35] !== t4 || $[36] !== t7) {
    t15 = <InputField autoComplete="cc-csc" inputMode="numeric" label={t3} help={t4} minLength={t7} maxLength={t10} validate={t11} maskOptions={t12} onFocus={t13} value={t14} {...fieldProps} />;
    $[28] = fieldProps;
    $[29] = t10;
    $[30] = t11;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t3;
    $[35] = t4;
    $[36] = t7;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  return t15;
};